import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { getMediaUrl, variousURLs, arcademicsIntroDuration } from "../../config";
import ArcademicsHTML5 from "./arcademicsHTML5";

export default function DesktopContent({ game, isArcademics }) {
  const ifrm = useRef();

  useEffect(() => {
    if (!isArcademics && game?.shortname) {
      ifrm.current.contentWindow.location.replace(`${getMediaUrl()}/games/${game.shortname}/html/index.html`);
    }
  }, [game]);

  if (isArcademics) {
    return (
      <ArcademicsHTML5
        gameName={game.arcademicsName}
        settings={{
          introURL: variousURLs.arcademics.intro,
          introDuration: arcademicsIntroDuration,
          endGameEnabled: false,
          printEnabled: false,
        }}
      />
    );
  }

  return (
    <iframe
      id="abcya-game-iframe"
      title={game.shortname}
      frameBorder="0"
      ref={ifrm}
      allow="accelerometer *;magnetometer *;gyroscope *;"
    />
  );
}

DesktopContent.propTypes = {
  game: PropTypes.object.isRequired,
  isArcademics: PropTypes.bool.isRequired,
};
